import ReplayIcon from '@mui/icons-material/Replay';

const icons = {
  ReplayIcon
};

const caseReopen = {
  id: 'caseReopen',
  type: 'group',
  children: [
    {
      id: 'caseReopen',
      title: 'Cases Reopen',
      type: 'item',
      url: '/ReopenCases',
      icon: icons.ReplayIcon,
    }
  ]
};

export default caseReopen;
